import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { makeKeyed } from '../utils/utils';
import { marketingCategories, salesCategories, serviceCategories } from 'academy-common-lib/constants/categories';
import { UserTrackStatuses } from './TracksConstants';
export const AWARD_TYPES = ['ONLY_SHOW_CERTIFICATE_COURSES'];
export const CATEGORIES = ['MARKETING', 'SALES', 'SERVICE', 'CONTACT_MANAGEMENT', 'CONTENT_MARKETING', 'EMAIL_MARKETING', 'LEAD_GENERATION', 'AUTOMATION', 'SEO', 'SOCIAL_MEDIA', 'WEBSITE_DESIGN', 'CONTACT_MANAGEMENT_SALES', 'INBOUND_SALES', 'SALES_ENABLEMENT', 'CONTACT_MANAGEMENT_SERVICE', 'OPERATIONS', 'WEB_DESIGN', 'WEB_DEVELOPMENT', 'DATA_PRIVACY', 'INBOUND_MARKETING', 'REPORTING_AND_PERFORMANCE', 'INBOUND_SERVICE'];
export const LESSON_TYPES = ['LESSON', 'TEMPLATE', 'EBOOK'];
export const CONTENT_TYPES = ['COURSE', 'LESSON', 'SHORT_FORM_CONTENT', 'TEMPLATE', 'EBOOK'];
export const DURATIONS = ['THIRTY_MINUTES_OR_LESS', 'THIRTY_MINUTES_TO_ONE_HOUR', 'ONE_TO_TWO_HOURS', 'TWO_TO_THREE_HOURS', 'MORE_THAN_THREE_HOURS'];
export const LANGUAGES = ['EN', 'ES', 'DE', 'JA', 'FR', 'PT'];
export const LEVELS = ['BEGINNER', 'INTERMEDIATE', 'ADVANCED'];
export const SORT_BYS = ['RECENTLY_ACCESSED', 'TITLE_ASC', 'TITLE_DESC'];
export const SORT_BY_MY_PLAYLISTS = ['RELEVANCE_DESCENDING', 'RELEVANCE_ASCENDING', 'RECENTLY_ACCESSED_DESCENDING', 'RECENTLY_ACCESSED_ASCENDING'];
export const SORT_BY_MY_PLAYLISTS_NO_SEARCH = ['RECENTLY_ACCESSED_DESCENDING', 'RECENTLY_ACCESSED_ASCENDING'];
export const PROGRESS_STATUS = [UserTrackStatuses.IN_PROGRESS, UserTrackStatuses.COMPLETED];
export const ASSIGNED_BY = ['EVERYONE', 'ME'];
export const STATUSES = ['IN_PROGRESS', 'COMPLETED', 'NOT_STARTED'];
export const CREATED_BY = ['ME', 'ARCHIVED'];
export const TOOLS = ['MARKETING_HUB_TOOLS', 'SALES_HUB_TOOLS', 'SERVICE_HUB_TOOLS', 'ADS', 'BLOGS', 'CAMPAIGNS', 'MARKETING_CONTACTS', 'MARKETING_CRM', 'CTA', 'DESIGN_MANAGER', 'EMAIL', 'FORMS', 'LANDING_PAGE', 'LISTS', 'MARKETING_REPORTS', 'SEO', 'SOCIAL', 'TEMPLATES', 'WEBSITE', 'WORKFLOWS', 'SALES_CONTACTS', 'SALES_CRM', 'DEALS', 'DOCUMENTS', 'MEETINGS', 'SALES_REPORTS', 'SEQUENCES', 'SALES_SNIPPETS', 'TASKS', 'SERVICE_HUB_CONTACTS', 'SERVICE_HUB_CRM', 'CUSTOMER_FEEDBACK', 'KNOWLEDGE_BASE', 'SERVICE_HUB_REPORTS', 'TICKETS', 'HUBSPOT_CMS', 'DEVELOPER_TOOLS', 'INTEGRATIONS', 'ACCOUNT_SETUP', 'AUTOMATION', 'PROSPECTING'];
export const FILTER_CONSTS = makeKeyed({
  AWARD_TYPES,
  CATEGORIES,
  CONTENT_TYPES,
  DURATIONS,
  LANGUAGES,
  LESSON_TYPES,
  LEVELS,
  SORT_BYS,
  STATUSES,
  TOOLS,
  CREATED_BY
});
const minute = 60;
const hour = minute * 60;
export const DURATION_BOUNDS = {
  THIRTY_MINUTES_OR_LESS: [0, minute * 30],
  THIRTY_MINUTES_TO_ONE_HOUR: [minute * 30, hour],
  ONE_TO_TWO_HOURS: [hour, hour * 2],
  TWO_TO_THREE_HOURS: [hour * 2, hour * 3],
  MORE_THAN_THREE_HOURS: [hour * 3, hour * 1000]
};
export const FILTER_TYPES = {
  CATEGORY: 'cat',
  SEARCH: 'search',
  SEARCH_USER: 'searchUser',
  SEARCH_TEAMS: 'searchTeams',
  SORT_BY: 'sortBy',
  ASSIGNED_BY: 'assignedBy',
  AWARD_TYPE: 'awardType',
  LEVEL: 'level',
  DURATION: 'duration',
  CONTENT_TYPE: 'contentType',
  LANGUAGE: 'language',
  TOOLS: 'tools',
  CREATED_BY: 'createdBy',
  MY_PLAYLISTS_TYPE: 'myPlaylistsType',
  SORT_BY_MY_PLAYLISTS: 'sortByMyPlaylists',
  PROGRESS_STATUS: 'progressStatus'
};
export const FILTER_TYPES_OTHER = {
  CATEGORIES: 'cat',
  TOOLS: 'tools',
  SEARCH: 'search'
};
export const MarketingHubTools = ImmutableSet(['ADS', 'BLOGS', 'CAMPAIGNS', 'MARKETING_CONTACTS', 'MARKETING_CRM', 'CTA', 'DESIGN_MANAGER', 'EMAIL', 'FORMS', 'LANDING_PAGE', 'LISTS', 'MARKETING_REPORTS', 'SEO', 'SOCIAL', 'TEMPLATES', 'WEBSITE', 'WORKFLOWS']);
export const SalesHubTools = ImmutableSet(['SALES_CONTACTS', 'SALES_CRM', 'DEALS', 'DOCUMENTS', 'MEETINGS', 'SALES_REPORTS', 'SEQUENCES', 'SALES_SNIPPETS', 'TASKS', 'PROSPECTING']);
export const ServiceHubTools = ImmutableSet(['SERVICE_HUB_CONTACTS', 'SERVICE_HUB_CRM', 'CUSTOMER_FEEDBACK', 'KNOWLEDGE_BASE', 'SERVICE_HUB_REPORTS', 'TICKETS', 'AUTOMATION']);
const MarketingCategoriesSet = ImmutableSet(marketingCategories);
const SalesCategoriesSet = ImmutableSet(salesCategories);
const ServiceCategoriesSet = ImmutableSet(serviceCategories);
export const getCategoryGroup = category => {
  return MarketingCategoriesSet.contains(category) || category === 'MARKETING' ? 'MARKETING' : SalesCategoriesSet.contains(category) || category === 'SALES' ? 'SALES' : ServiceCategoriesSet.contains(category) || category === 'SERVICE' ? 'SERVICE' : '';
};
export const getToolGroup = tool => {
  return MarketingHubTools.contains(tool) || tool === 'MARKETING_HUB_TOOLS' ? 'MARKETING_HUB_TOOLS' : SalesHubTools.contains(tool) || tool === 'SALES_HUB_TOOLS' ? 'SALES_HUB_TOOLS' : ServiceHubTools.contains(tool) || tool === 'SERVICE_HUB_TOOLS' ? 'SERVICE_HUB_TOOLS' : '';
};
const addAllOptionToCategories = (categorySet, allIndex) => {
  return categorySet.add(allIndex).sort((a, b) => a === allIndex ? -1 : b === allIndex ? 1 : a.localeCompare(b));
};
export const mapSoftwareFiltersWithAll = hsSoftwareFilters => ImmutableMap({
  MARKETING_HUB_TOOLS: addAllOptionToCategories(MarketingHubTools.intersect(hsSoftwareFilters), 'MARKETING_HUB_TOOLS'),
  SALES_HUB_TOOLS: addAllOptionToCategories(SalesHubTools.intersect(hsSoftwareFilters), 'SALES_HUB_TOOLS'),
  SERVICE_HUB_TOOLS: addAllOptionToCategories(ServiceHubTools.intersect(hsSoftwareFilters), 'SERVICE_HUB_TOOLS')
}).merge(hsSoftwareFilters.subtract(MarketingHubTools, SalesHubTools, ServiceHubTools).toMap());
export const mapWizardCategories = (subcategories, toolCategories) => {
  return ImmutableMap({
    MARKETING: addAllOptionToCategories(MarketingCategoriesSet.intersect(subcategories), 'MARKETING'),
    SALES: addAllOptionToCategories(SalesCategoriesSet.intersect(subcategories), 'SALES'),
    SERVICE_SUPPORT: addAllOptionToCategories(ServiceCategoriesSet.intersect(subcategories), 'SERVICE'),
    WEB_DESIGN_DEVELOPMENT: ImmutableSet(),
    HUBSPOT_SOFTWARE: mapSoftwareFiltersWithAll(toolCategories)
  });
};
export const mapAcad021Categories = categories => ImmutableMap({
  MARKETING: addAllOptionToCategories(MarketingCategoriesSet.intersect(categories), 'MARKETING'),
  SALES: addAllOptionToCategories(SalesCategoriesSet.intersect(categories), 'SALES'),
  SERVICE: addAllOptionToCategories(ServiceCategoriesSet.intersect(categories), 'SERVICE')
}).merge(categories.subtract(MarketingCategoriesSet, SalesCategoriesSet, ServiceCategoriesSet).toMap());